<template>
  <div>
    <main-layout>
      <v-snackbar v-model="showCopyLink" :timeout="6000" color="green" :top="true"
        >{{ $t('Link Copied') }}!</v-snackbar
      >
      <v-tabs color="white" v-model="tab" :slider-color="$vuetify.theme.primary" show-arrows>
        <v-tab href="#setting" ripple>{{ $t('Setting') }}</v-tab>
        <v-tab href="#socialConnect" ripple>{{ $t('Social Connect') }}</v-tab>
      </v-tabs>
      <template v-if="tab === 'setting'">
        <v-container>
          <v-layout class="mb-5">
            <v-flex>
              <div style="margin-top: 10px">{{ $t('activate_bot') }}</div>
              <div class="red--text">
                ***
                {{ $t('Information will not be recorded in analytics if the bot is inactivated2') }}
              </div>
            </v-flex>
            <v-flex shrink>
              <toggle-button
                class="mt-2"
                :value="selectedBot.status"
                :sync="true"
                :color="$vuetify.theme.success"
                @change="toggleBotStatus"
                :labels="{ checked: 'ON', unchecked: 'OFF' }"
                style="display: inline-block"
              />
            </v-flex>
          </v-layout>
          <div
            v-if="selectedBot.status"
            class="hr"
            style="margin-top: 20px; border-color: rgba(0,0,0,.12);"
          ></div>
          <div
            v-if="selectedBot.status"
            class="text-xs-center"
            style="margin: -13px;margin-bottom: 10px;"
          >
            <a
              class="text btn-advanced"
              href="javascript:void(0);"
              @click="onOffbotToggle = !onOffbotToggle"
              style="position:relative"
            >
              <i
                class="fa"
                :class="{ 'fa-angle-down': !onOffbotToggle, 'fa-angle-up': onOffbotToggle }"
              ></i>
            </a>
          </div>

          <template v-if="onOffbotToggle && selectedBot.status">
            <v-layout v-if="status_facebook" wrap row>
              <v-flex xs8>
                <div class="pl-2 pt-3">{{ $t('Activate bot Facebook') }}</div>
              </v-flex>
              <v-flex xs4 class="text-xs-right">
                <div class="pt-2">
                  <toggle-button
                    class="mt-2"
                    :value="toggleFacebook"
                    :sync="true"
                    :color="$vuetify.theme.success"
                    @change="toggleOnFacebook"
                    :labels="{ checked: 'ON', unchecked: 'OFF' }"
                    style="display: inline-block"
                  />
                </div>
              </v-flex>
            </v-layout>
            <v-layout v-if="status_line" wrap row>
              <v-flex xs8>
                <div class="pl-2 pt-3">{{ $t('Activate bot LINE') }}</div>
              </v-flex>
              <v-flex xs4 class="text-xs-right">
                <div class="pt-2">
                  <toggle-button
                    class="mt-2"
                    :value="toggleLine"
                    :sync="true"
                    :color="$vuetify.theme.success"
                    @change="toggleOnLine"
                    :labels="{ checked: 'ON', unchecked: 'OFF' }"
                    style="display: inline-block"
                  />
                </div>
              </v-flex>
            </v-layout>
            <v-layout v-if="status_ig" wrap row>
              <v-flex xs8>
                <div class="pl-2 pt-3">{{ $t('Activate bot Instagram') }}</div>
              </v-flex>
              <v-flex xs4 class="text-xs-right">
                <div class="pt-2">
                  <toggle-button
                    class="mt-2"
                    :value="toggleIg"
                    :sync="true"
                    :color="$vuetify.theme.success"
                    @change="toggleOnIg"
                    :labels="{ checked: 'ON', unchecked: 'OFF' }"
                    style="display: inline-block"
                  />
                </div>
              </v-flex>
            </v-layout>
            <v-layout v-if="status_whatsapp" wrap row>
              <v-flex xs8>
                <div class="pl-2 pt-3">{{ $t('activate_bot') }} WhatsApp</div>
              </v-flex>
              <v-flex xs4 class="text-xs-right">
                <div class="pt-2">
                  <toggle-button
                    class="mt-2"
                    :value="toggleWhatsapp"
                    :sync="true"
                    :color="$vuetify.theme.success"
                    @change="toggleOnWhatsapp"
                    :labels="{ checked: 'ON', unchecked: 'OFF' }"
                    style="display: inline-block"
                  />
                </div>
              </v-flex>
            </v-layout>
            <v-layout v-if="status_google" wrap row>
              <v-flex xs8>
                <div class="pl-2 pt-3">{{ $t('activate_bot') }} Google</div>
              </v-flex>
              <v-flex xs4 class="text-xs-right">
                <div class="pt-2">
                  <toggle-button
                    class="mt-2"
                    :value="toggleGoogle"
                    :sync="true"
                    :color="$vuetify.theme.success"
                    @change="toggleOnGoogle"
                    :labels="{ checked: 'ON', unchecked: 'OFF' }"
                    style="display: inline-block"
                  />
                </div>
              </v-flex>
            </v-layout>
            <v-divider class="my-3" />
          </template>

          <manage-open-time-bot v-if="selectedBot.status"></manage-open-time-bot>
        </v-container>
        <v-divider></v-divider>
        <v-container>
          <v-layout wrap>
            <v-flex xs8>
              <div style="margin-top: 10px">
                {{ $t('Time setting for bot to not reply the same question.') }}
                <a
                  href="https://tinyurl.com/2p84rnuk"
                  target="blank"
                  ><i style="font-size: 16px; color: #ed1e79;" class="fas fa-question-circle"></i
                ></a>
              </div>
            </v-flex>
            <v-flex xs4 class=" text-xs-right">
              <template v-if="isEditnotReplyWithinSecond">
                <toggle-button
                  class="mt-2"
                  :value="pauseStatus"
                  :sync="true"
                  :color="$vuetify.theme.success"
                  @change="togglePauseStatus"
                  :labels="{ checked: 'ON', unchecked: 'OFF' }"
                  style="display: inline-block"
                />
              </template>

              <v-btn
                outline
                fab
                small
                color="primary"
                v-if="!isEditnotReplyWithinSecond"
                @click="isEditnotReplyWithinSecond = true"
              >
                <v-icon>edit</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <div class="mt-2">
            <div v-if="pauseStatus" class="form-control">
              <label
                >{{
                  $t('Time period for bot to not reply the same question. ( maximum 10000 minutes)')
                }}
              </label>
              <input
                v-if="isEditnotReplyWithinSecond"
                type="number"
                pattern="[1-9]*"
                inputmode="numeric"
                v-model="notReplyWithinSecond"
                class="form-control"
                @change="checkValue"
              />
              <h1 v-else>{{ notReplyWithinSecond }}m</h1>
            </div>
            <label for>{{
              $t('* Note: Affect only for Conversation Page (not include Reply to Comment Page)')
            }}</label>
            <div class="text-xs-center mt-4 info--text" v-if="isEditnotReplyWithinSecond">
              <v-btn outline color="grey" @click="cancelIsEditnotReplyWithinSecond">{{
                $t('cancel')
              }}</v-btn>
              <v-btn depressed color="primary" @click="savePauseStatus">{{ $t('Save') }}</v-btn>
            </div>
          </div>
        </v-container>
        <v-divider></v-divider>

        <v-container>
          <v-layout>
            <v-flex shrink
              >{{ $t('Typing Time') }}
              <a
                href="https://tinyurl.com/2p95usku"
                target="blank"
                ><i style="font-size: 16px; color: #ed1e79;" class="fas fa-question-circle"></i></a
            ></v-flex>
            <v-flex class="text-xs-right">
              <v-btn
                outline
                fab
                small
                color="primary"
                v-if="!isEditDelay"
                @click="isEditDelay = true"
              >
                <v-icon>edit</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>

          <h1>{{ delayMessageTime }}s</h1>
          <label for>{{
            $t(
              'User can set the typing time for Bot to reply, and it will apply to all conversation.'
            )
          }}</label>

          <div v-if="isEditDelay">
            <v-slider
              v-model="delayMessageTime"
              :color="$vuetify.theme.primary"
              ticks
              always-dirty
              min="0"
              max="10"
              step="0.5"
              thumb-label
              @change="onChangeDelayMessage"
            >
              <template v-slot:prepend>
                <a href="javascript:void(0)" @click="decrementDelayMessage">
                  <span class="fas fa-minus"></span>
                </a>
              </template>

              <template v-slot:append>
                <a href="javascript:void(0)" @click="incrementDelayMessage">
                  <span class="fas fa-plus"></span>
                </a>
              </template>
            </v-slider>

            <div class="text-xs-center">
              <v-btn outline color="grey" @click="onCancelEditDelayMessage">{{
                $t('cancel')
              }}</v-btn>
              <v-btn depressed color="primary" @click="onSaveEditDelayMessage">{{
                $t('Save')
              }}</v-btn>
            </div>
          </div>
        </v-container>

        <v-divider></v-divider>
        <AdminHandOver v-if="!loadingSetting"></AdminHandOver>

        <v-divider></v-divider>
        <v-container>
          <h2>
            {{ $t('Line Notify') }}
            <a
              target="blank"
              href="https://tinyurl.com/2p82ydvv"
            >
              <i style="font-size: 20px" class="fas fa-question-circle"></i>
            </a>
          </h2>
          <div class="text-xs-center" v-if="loadingLineNotify"></div>
          <div
            v-else
            style="position: relative; padding: 10px 0px"
            :style="{ 'min-height': $store.getters.getPackage != 'premium' ? '215px' : '0px' }"
          >
            <v-premium-plan-popup
              :showAll="false"
              v-if="$store.getters.getPackage != 'premium'"
              style="border-radius: 10px"
              text="Upgrade to Premium, starting at 500 baht / month to be notified every chatbot’s movement via your personal line/line group. Such as the question that bot cannot answer or when the order comes in"
            ></v-premium-plan-popup>
            <v-layout wrap v-if="!isLinkedLineNotify">
              <v-flex xs5 sm8>{{ $t('Not connect to the account') }}</v-flex>
              <v-flex xs7 sm4 class="text-xs-right">
                <template v-if="$store.getters.getPackage == 'premium'">
                  <v-btn :href="lineNotifyLink" color="primary" outline>{{
                    $t('Link Account')
                  }}</v-btn>
                </template>
                <template v-else>
                  <v-btn color="primary" outline>{{ $t('Link Account') }}</v-btn>
                </template>
              </v-flex>
            </v-layout>

            <div
              v-for="(person, index) in linenotifylist"
              :key="'line_' + index"
              style="margin-bottom: 10px"
            >
              <div class="z-border-red">
                <v-layout wrap>
                  <v-flex xs8 style="padding: 10px 20px">
                    <img
                      :src="
                        'https://graph.facebook.com/' +
                          person.adminid +
                          '/picture?type=square&SameSite=None' || person.line_picture_url
                      "
                      width="50"
                      @error="onFailLoad"
                      height="50"
                      :alt="person.name"
                      style="border-radius: 50%; margin-right: 10px; float: left"
                    />
                    <div style="margin-top: 13px">{{ person.name }}</div>
                  </v-flex>
                  <v-flex
                    xs4
                    class=" text-xs-right"
                    style="padding: 10px 20px"
                    v-if="person.adminid == $store.state.userid || getBotPageRole == true"
                  >
                    <v-btn outline color="primary" small fab @click="deleteLineNotify(person)">
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </div>
            </div>

            <div class="mt-3" v-if="linenotifylist && linenotifylist.length > 0">
              <h3>{{ $t('Notification Settings') }}</h3>

              <v-layout wrap>
                <v-flex xs8>
                  <div class="pl-2 pt-2">{{ $t('All conversation') }}</div>
                </v-flex>
                <v-flex xs4 class="text-xs-right">
                  <toggle-button
                    class="mt-2"
                    :value="linenotify.notify_intent"
                    :sync="true"
                    :color="$vuetify.theme.success"
                    @change="onChangeLineNotify('notify_intent')"
                    :labels="{ checked: 'ON', unchecked: 'OFF' }"
                    style="display: inline-block"
                  />
                </v-flex>
              </v-layout>

              <transition name="fade">
                <v-layout wrap row v-if="linenotify.notify_intent">
                  <v-flex xs8>
                    <div class="pl-2 pt-3">{{ $t('Selected conversation') }}</div>
                  </v-flex>
                  <v-flex xs4 class="text-xs-right">
                    <div class="pt-3">
                      <a
                        href="javascript:void(0);"
                        @click="showEditLineNotifyConversation = true"
                        >{{ $t('edit') }}</a
                      >
                    </div>
                  </v-flex>
                </v-layout>
              </transition>

              <v-divider class="my-3" />

              <v-layout wrap row>
                <v-flex xs8>
                  <div class="pl-2 pt-2">{{ $t('All Comments') }}</div>
                </v-flex>
                <v-flex xs4 class="text-xs-right">
                  <toggle-button
                    class="mt-2"
                    :value="linenotify.notify_comment"
                    :sync="true"
                    :color="$vuetify.theme.success"
                    @change="onChangeLineNotify('notify_comment')"
                    :labels="{ checked: 'ON', unchecked: 'OFF' }"
                    style="display: inline-block"
                  />
                </v-flex>
              </v-layout>

              <transition name="fade">
                <v-layout wrap row v-if="linenotify.notify_comment">
                  <v-flex xs8>
                    <div class="pl-2 pt-3">{{ $t('Selected comment') }}</div>
                  </v-flex>
                  <v-flex xs4 class="text-xs-right">
                    <div class="pt-3">
                      <a
                        href="javascript:void(0);"
                        @click="showEditLineNotifyReplyComment = true"
                        >{{ $t('edit') }}</a
                      >
                    </div>
                  </v-flex>
                </v-layout>
              </transition>

              <v-divider class="my-3" />

              <template v-if="selectedBot.theme == 'ecommercebasic'">
                <v-layout wrap row>
                  <v-flex xs8>
                    <div class="pl-2 pt-2">{{ $t('notify_out_of_stock') }}</div>
                  </v-flex>
                  <v-flex xs4 class="text-xs-right">
                    <toggle-button
                      class="mt-2"
                      :value="linenotify.notify_product_out_of_stock"
                      :sync="true"
                      :color="$vuetify.theme.success"
                      @change="onChangeLineNotify('notify_product_out_of_stock')"
                      :labels="{ checked: 'ON', unchecked: 'OFF' }"
                      style="display: inline-block"
                    />
                  </v-flex>
                  <v-flex xs12 class="pl-2">
                    <select-specific-linenotify
                      :key="linenotify.notify_product_out_of_stock_ids"
                      v-model="linenotify.notify_product_out_of_stock_ids"
                      @onSave="onChangeSpecifyLineNotify()"
                    ></select-specific-linenotify>
                  </v-flex>
                </v-layout>
                <v-layout wrap row>
                  <v-flex xs8>
                    <div class="pl-2 pt-2">{{ $t('notify_almost_out_of_stock') }}</div>
                  </v-flex>
                  <v-flex xs4 class="text-xs-right">
                    <toggle-button
                      class="mt-2"
                      :value="linenotify.notify_product_almost_out_of_stock"
                      :sync="true"
                      :color="$vuetify.theme.success"
                      @change="onChangeLineNotify('notify_product_almost_out_of_stock')"
                      :labels="{ checked: 'ON', unchecked: 'OFF' }"
                      style="display: inline-block"
                    />
                  </v-flex>
                  <v-flex xs12 class="pl-2">
                    <select-specific-linenotify
                      :key="linenotify.notify_product_almost_out_of_stock_ids"
                      v-model="linenotify.notify_product_almost_out_of_stock_ids"
                      @onSave="onChangeSpecifyLineNotify()"
                    ></select-specific-linenotify>
                  </v-flex>
                </v-layout>
                <v-layout wrap row>
                  <v-flex xs8>
                    <div class="pl-2 pt-2">{{ $t('Notify when customer ordered') }}</div>
                  </v-flex>
                  <v-flex xs4 class="text-xs-right">
                    <toggle-button
                      class="mt-2"
                      :value="linenotify.notify_neworder"
                      :sync="true"
                      :color="$vuetify.theme.success"
                      @change="onChangeLineNotify('notify_neworder')"
                      :labels="{ checked: 'ON', unchecked: 'OFF' }"
                      style="display: inline-block"
                    />
                  </v-flex>
                  <v-flex xs12 class="pl-2">
                    <select-specific-linenotify
                      :key="linenotify.notify_neworder_ids"
                      v-model="linenotify.notify_neworder_ids"
                      @onSave="onChangeSpecifyLineNotify()"
                    ></select-specific-linenotify>
                  </v-flex>
                </v-layout>

                <v-layout wrap row>
                  <v-flex xs8>
                    <div class="pl-2 pt-2">{{ $t('Notify when customer paid') }}</div>
                  </v-flex>
                  <v-flex xs4 class="text-xs-right">
                    <toggle-button
                      class="mt-2"
                      :value="linenotify.notify_payment"
                      :sync="true"
                      :color="$vuetify.theme.success"
                      @change="onChangeLineNotify('notify_payment')"
                      :labels="{ checked: 'ON', unchecked: 'OFF' }"
                      style="display: inline-block"
                    />
                  </v-flex>
                  <v-flex xs12 class="pl-2">
                    <select-specific-linenotify
                      :key="linenotify.notify_payment_ids"
                      v-model="linenotify.notify_payment_ids"
                      @onSave="onChangeSpecifyLineNotify()"
                    ></select-specific-linenotify>
                  </v-flex>
                </v-layout>
                <v-layout wrap row>
                  <v-flex xs8>
                    <div class="pl-2 pt-2">{{ $t('Notify when token expired') }}</div>
                  </v-flex>
                  <v-flex xs4 class="text-xs-right">
                    <toggle-button
                      class="mt-2"
                      :value="linenotify.notify_token_expired"
                      :sync="true"
                      :color="$vuetify.theme.success"
                      @change="onChangeLineNotify('notify_token_expired')"
                      :labels="{ checked: 'ON', unchecked: 'OFF' }"
                      style="display: inline-block"
                    />
                  </v-flex>
                  <v-flex xs12 class="pl-2">
                    <select-specific-linenotify
                      :key="linenotify.notify_token_expired_ids"
                      v-model="linenotify.notify_token_expired_ids"
                      @onSave="onChangeSpecifyLineNotify()"
                    ></select-specific-linenotify>
                  </v-flex>
                </v-layout>
                <v-layout wrap row>
                  <v-flex xs8>
                    <div class="pl-2 pt-2">{{ $t('notify_when_expired') }}</div>
                  </v-flex>
                  <v-flex xs4 class="text-xs-right">
                    <toggle-button
                      class="mt-2"
                      :value="linenotify.notify_package_expired"
                      :sync="true"
                      :color="$vuetify.theme.success"
                      @change="onChangeLineNotify('notify_package_expired')"
                      :labels="{ checked: 'ON', unchecked: 'OFF' }"
                      style="display: inline-block"
                    />
                  </v-flex>
                  <v-flex xs12 class="pl-2">
                    <select-specific-linenotify
                      :key="linenotify.notify_package_expired_ids"
                      v-model="linenotify.notify_package_expired_ids"
                      @onSave="onChangeSpecifyLineNotify()"
                    ></select-specific-linenotify>
                  </v-flex>
                </v-layout>
              </template>

              <manage-single-line-notify
                v-model="showEditLineNotifyConversation"
                @close="showEditLineNotifyConversation = false"
              ></manage-single-line-notify>

              <manage-single-line-notify
                type="replycomment"
                v-model="showEditLineNotifyReplyComment"
                @close="showEditLineNotifyReplyComment = false"
              ></manage-single-line-notify>
            </div>
          </div>
        </v-container>

        <template v-if="selectedBot && selectedBot.hasOwnProperty('synctagsfacebook_status')">
          <v-divider />
          <facebook-tags></facebook-tags>
        </template>
        <template v-if="getBotPageRole">
          <v-divider></v-divider>

          <div class="text-xs-center" style="margin: -13px;">
            <a
              class="text btn-advanced"
              href="javascript:void(0);"
              @click="toggle = !toggle"
              style="position:relative"
            >
              <i class="fa" :class="{ 'fa-angle-down': !toggle, 'fa-angle-up': toggle }"></i>
            </a>
          </div>
          <template v-if="toggle">
            <v-container>
              <template v-if="getBotPageRole">
                <v-layout>
                  <v-flex>{{ $t('remove bot') }}</v-flex>
                  <v-flex class="text-xs-right">
                    <v-btn color="red" depressed @click="onUnsubscribeBot" dark>{{
                      $t('remove bot')
                    }}</v-btn>
                  </v-flex>
                </v-layout>
              </template>
            </v-container>
            <v-divider />
          </template>
        </template>
      </template>
      <template v-if="tab === 'socialConnect'">
        <v-container>
          <social-connect></social-connect>
        </v-container>

        <v-divider></v-divider>
        <template
          v-if="
            (!selectedBot.line_modular_botid && line.line_access_token) ||
              (isZwizAdmin && !selectedBot.line_modular_botid)
          "
        >
          <v-container id="_line" style="position: relative">
            <v-layout row>
              <v-flex>
                <h1>Line Chatbot (depreciated)</h1>
              </v-flex>
              <v-flex shrink>
                <v-btn
                  fab
                  small
                  outline
                  color="primary"
                  v-if="
                    !isEditLine &&
                      $store.getters.getPackage == 'premium' &&
                      isZwizAdmin &&
                      !selectedBot.line_modular_botid
                  "
                  @click="isEditLine = true"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>

            <div style="position: relative; padding-top: 15px; padding-bottom: 15px">
              <v-premium-plan-popup
                :showAll="false"
                marginTop="65"
                v-if="$store.getters.getPackage != 'premium'"
                style="border-radius: 10px"
              ></v-premium-plan-popup>
              <ul class="list-group vertical-steps">
                <li class="list-group-item" v-if="isZwizAdmin && !selectedBot.line_modular_botid">
                  <v-layout row>
                    <v-flex>
                      <textarea
                        class="form-control"
                        ref="shareLink"
                        style="resize: vertical; min-height: 90px; background: #eee"
                        onclick="this.select()"
                        readonly="true"
                        v-model="webhookUrl"
                      ></textarea>
                    </v-flex>
                    <v-flex shrink>
                      <v-btn
                        outline
                        color="primary"
                        fab
                        small
                        v-clipboard:copy="webhookUrl"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                        style="position: relative"
                      >
                        <span class="fas fa-copy"></span>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </li>
                <li class="list-group-item">
                  <label for="text">{{ $t('Channel Access Token') }}</label>
                  <div v-if="isEditLine" class="form-control">
                    <textarea
                      class="form-control"
                      rows="5"
                      maxlength="600"
                      v-model="line.line_access_token"
                      style="resize: vertical; min-height: 90px"
                      :placeholder="'Access Token'"
                    ></textarea>
                  </div>
                  <div v-else class="primary--text" style="word-break: break-all">
                    {{ line.line_access_token ? line.line_access_token : '-' }}
                  </div>
                </li>
                <li class="list-group-item">
                  <label for="text">{{ $t('Channel Secret') }}</label>
                  <div v-if="isEditLine" class="form-control">
                    <textarea
                      class="form-control"
                      rows="5"
                      maxlength="600"
                      v-model="line.line_channel_secret"
                      style="resize: vertical; min-height: 90px"
                      :placeholder="'Channel Secret'"
                    ></textarea>
                  </div>
                  <div v-else class="primary--text" style="word-break: break-all">
                    {{ line.line_channel_secret ? line.line_channel_secret : '-' }}
                  </div>
                </li>
              </ul>

              <div class="text-xs-center" style="margin-top: 15px" v-if="isEditLine">
                <v-btn outline color="grey" @click="cancelEditLine">{{ $t('cancel') }}</v-btn>
                <v-btn depressed color="primary" @click="saveEditLine">{{ $t('Save') }}</v-btn>
              </div>
            </div>
          </v-container>
          <v-divider />
        </template>

        <v-container>
          <v-layout wrap>
            <v-flex xs6>Bot id</v-flex>
            <v-flex xs6
              >{{ selectedBot.pageid }}
              <v-btn
                small
                fab
                flat
                v-clipboard:copy="selectedBot.pageid"
                v-clipboard:success="onCopy"
                v-clipboard:error="onCopyError"
                color="primary"
              >
                <v-icon>content_copy</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </template>
      <div class="my-5"></div>
    </main-layout>

    <v-snackbar v-model="showCopy" :timeout="6000" color="green" :top="true"
      >{{ $t('Copied') }}!</v-snackbar
    >
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import ViewPackage from '@/components/view/setting/ViewPackage'
import ManageSingleLineNotify from './ManageSingleLineNotify'
import SupportCode from './SupportCode'
import ManageOpenTimeBot from './ManageOpenTimeBot'
import dayjs from 'dayjs'
import AdminHandOver from './adminHandOver.vue'
import config from '@/config'
import FacebookTags from './FacebookTags'
import SelectSpecificLinenotify from './SelectSpecificLinenotify'
import CryptoJS from 'crypto-js'
import SocialConnect from './SocialConnect'
import { ToggleButton } from 'vue-js-toggle-button'

export default {
  data: function() {
    return {
      toggle: false,
      onOffbotToggle: false,
      toggleLine: false,
      toggleIg: false,
      toggleFacebook: false,
      toggleGoogle: false,
      toggleWhatsapp: false,
      showCopy: false,
      tab: 'setting',
      cachedNotReply: null,
      expriedDate: null,
      expriedTime: null,
      isEdit: false,
      botStatus: false,
      pauseStatus: false,
      notReplyWithinSecond: 0,
      isEditLine: false,
      line: {
        line_access_token: null,
        line_channel_secret: null
      },
      showCopyLink: false,
      delayMessageTime: 0,
      isEditDelay: false,
      isEditnotReplyWithinSecond: false,
      loadingLineNotify: true,
      linenotifylist: [],
      showEditLineNotifyConversation: false,
      showEditLineNotifyReplyComment: false,
      linenotify: {
        notify_comment: false,
        notify_intent: false,
        notify_neworder: false,
        notify_neworder_ids: '',
        notify_payment: false,
        notify_payment_ids: '',
        notify_token_expired: false,
        notify_token_expired_ids: '',
        notify_package_expired: false,
        notify_package_expired_ids: ''
      },
      status_facebook: false,
      status_line: false,
      status_ig: false,
      status_whatsapp: false,
      status_google: false
    }
  },
  watch: {
    'selectedBot.status': function() {
      const vm = this
      vm.botStatus = vm.selectedBot.status
    }
  },
  async mounted() {
    const vm = this
    vm.tab = vm.$route.query.tab || 'setting'
    vm.toggleLine = vm.selectedBot.line_status
    vm.toggleIg = vm.selectedBot.instagram_status
    vm.toggleFacebook = vm.selectedBot.facebook_status
    vm.toggleGoogle = vm.selectedBot.google_status
    vm.toggleWhatsapp = vm.selectedBot.whatsapp_status
    vm.botStatus = vm.selectedBot.status
    vm.loadingLineNotify = true
    vm.$store.dispatch('loadSetting')
    try {
      await vm.$store.dispatch('updateBotDetail')

      vm.linenotify = {
        notify_comment: vm.selectedBot.notify_comment,
        notify_intent: vm.selectedBot.notify_intent,
        notify_neworder: vm.selectedBot.notify_neworder,
        notify_payment: vm.selectedBot.notify_payment,
        notify_token_expired: vm.selectedBot.notify_token_expired,
        notify_product_out_of_stock: vm.selectedBot.notify_product_out_of_stock,
        notify_product_almost_out_of_stock: vm.selectedBot.notify_product_almost_out_of_stock,

        notify_neworder_ids: vm.selectedBot.notify_neworder_ids,
        notify_payment_ids: vm.selectedBot.notify_payment_ids,
        notify_token_expired_ids: vm.selectedBot.notify_token_expired_ids,
        notify_package_expired: JSON.parse(vm.selectedBot.notify_package_expired),
        notify_package_expired_ids: vm.selectedBot.notify_package_expired_ids,
        notify_product_out_of_stock_ids: vm.selectedBot.notify_product_out_of_stock_ids,
        notify_product_almost_out_of_stock_ids: vm.selectedBot.notify_product_almost_out_of_stock_ids
      }
    } catch (e) {
      console.error(e)
    }

    try {
      await vm.getPauseStatus()
    } catch (error) {}
    vm.loadingLineNotify = false
    vm.getLineNotify()
    try {
      await vm.getLineToken()
      vm.cached_line = JSON.stringify(vm.line)
      if (vm.$route.query.go === 'line') {
        $('.vb-content').animate({
          scrollTop: $(window).height() - $('#_line').height()
        })
      }
    } catch (error) {}

    try {
      vm.getDelayMessage()
      vm.cached_delay_message_time = vm.delayMessageTime
    } catch (error) {}

    const packages = vm.selectedBot.packages
    if (packages.includes('facebook')) {
      vm.status_facebook = true
    }
    if (packages.includes('line')) {
      vm.status_line = true
    }
    if (packages.includes('instagram')) {
      vm.status_ig = true
    }
    if (packages.includes('whatsapp')) {
      vm.status_whatsapp = true
    }
    if (packages.includes('google')) {
      vm.status_google = true
    }
  },
  components: {
    ViewPackage,
    ManageSingleLineNotify,
    SupportCode,
    ManageOpenTimeBot,
    AdminHandOver,
    FacebookTags,
    SelectSpecificLinenotify,
    SocialConnect,
    ToggleButton
  },
  computed: {
    isZwizAdmin() {
      try {
        return this.$store.state.userid.includes('zwiz')
      } catch (error) {
        return false
      }
    },
    selectedBotStatus() {
      return this.selectedBot.status
    },
    ...mapGetters({
      botlist: 'botlist',
      allPage: 'allPage',
      currentLang: 'currentLang',
      selectedBot: 'selectedBot',
      loadingSetting: 'getLoadingSetting',
      getBotPageRole: 'getBotPageRole'
    }),
    isLinkedLineNotify: function() {
      var vm = this
      if (!vm.selectedBot) {
        return false
      }
      return (
        vm.linenotifylist.findIndex(function(el) {
          return el.pageid == vm.selectedBot.pageid && el.adminid == vm.$store.state.userid
        }) > -1
      )
    },
    lineNotifyLink: function() {
      let query = [`lang=${this.currentLang || 'th'}`, `ref=zwizai`]
      let val = `{${query.join(',')}}`

      let encrpted = CryptoJS.AES.encrypt(val, 'zwizai').toString()

      let url =
        window.location.protocol +
        '//' +
        window.location.hostname +
        (window.location.port ? ':' + window.location.port : '') +
        `/linenotify&scope=notify&state=${encrpted}`

      return `https://notify-bot.line.me/oauth/authorize?response_type=code&client_id=${this.$store.state.line.notify}&redirect_uri=${url}`
    },
    selectedBot: {
      get() {
        if (this.$store.state.selectedBot == null) {
          return null
        }
        var now = dayjs()
        var expriedDate = dayjs(this.$store.state.selectedBot.expireat)
        this.expriedDate = parseInt(expriedDate.diff(now, 'days'))
        this.expriedTime = parseInt(expriedDate.diff(now, 'seconds'))
        return this.$store.state.selectedBot
      },
      set(bot) {
        let vm = this
        vm.currentBot = bot
        vm.$store.dispatch('selectBot', vm.currentBot)
        location.reload()
      }
    },
    webhookUrl: function() {
      return config.serverWebhookUrl + 'webhookline?facebookpageid=' + this.selectedBot.pageid
    }
  },
  methods: {
    async toggleOnFacebook() {
      this.toggleFacebook = !this.toggleFacebook
      this.$store.dispatch('loading')
      var data = {
        body: { facebook_status: this.toggleFacebook },
        pageId: this.selectedBot.pageid
      }
      var res = await api.toggleWeightShipping(data)
      if (res.success) {
      } else {
        this.toggleFacebook = !this.toggleFacebook
      }
      this.$store.dispatch('loading')
    },
    async toggleOnLine() {
      this.toggleLine = !this.toggleLine
      this.$store.dispatch('loading')
      var data = {
        body: { line_status: this.toggleLine },
        pageId: this.selectedBot.pageid
      }
      var res = await api.toggleWeightShipping(data)
      if (res.success) {
      } else {
        this.toggleLine = !this.toggleLine
      }
      this.$store.dispatch('loading')
    },
    async toggleOnIg() {
      this.toggleIg = !this.toggleIg
      this.$store.dispatch('loading')
      var data = {
        body: { instagram_status: this.toggleIg },
        pageId: this.selectedBot.pageid
      }
      var res = await api.toggleWeightShipping(data)
      if (res.success) {
      } else {
        this.toggleIg = !this.toggleIg
      }
      this.$store.dispatch('loading')
    },
    async toggleOnGoogle() {
      const vm = this
      vm.toggleGoogle = !vm.toggleGoogle
      vm.$store.dispatch('loading')
      const data = {
        body: { google_status: vm.toggleGoogle },
        pageId: vm.selectedBot.pageid
      }
      const res = await api.toggleWeightShipping(data)
      if (res.success) {
      } else {
        vm.toggleGoogle = !vm.toggleGoogle
      }
      vm.$store.dispatch('loading')
    },
    async toggleOnWhatsapp() {
      const vm = this
      vm.toggleWhatsapp = !vm.toggleWhatsapp
      vm.$store.dispatch('loading')
      var data = {
        body: { whatsapp_status: vm.toggleWhatsapp },
        pageId: vm.selectedBot.pageid
      }
      const res = await api.toggleWeightShipping(data)
      if (res.success) {
      } else {
        vm.toggleWhatsapp = !vm.toggleWhatsapp
      }
      vm.$store.dispatch('loading')
    },
    updateRoute: function() {
      try {
        this.$router
          .push({
            name: 'setting',
            path: '/billing',
            query: {
              tab: this.tab
            }
          })
          .catch(() => {})
      } catch (error) {}
      this.routeValue = JSON.stringify(this.$route.query)
    },
    onCopy() {
      let vm = this
      vm.showCopy = true
    },
    onCopyError() {},
    checkValue() {
      if (this.notReplyWithinSecond > 600000 / 60) {
        this.notReplyWithinSecond = 600000 / 60
      }
    },
    onUpdateSupportCode: function() {
      location.reload()
    },
    onChangeSpecifyLineNotify() {
      this.saveLineNotifyNotification()
    },
    onChangeLineNotify: function(type) {
      this.linenotify[type] = !this.linenotify[type]
      this.saveLineNotifyNotification()
    },
    saveLineNotifyNotification() {
      var data = this.linenotify
      data.pageid = this.selectedBot.pageid
      return new Promise((resolve, reject) => {
        api.saveLineNotifyNotification(data, function(error, response) {
          if (error) {
            reject(error)
          }
          resolve()
        })
      })
    },
    onFailLoad: function() {
      $(event.target).attr('src', '/static/img/assets/livechat/profile.png')
    },
    deleteLineNotify: function(person) {
      var vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to unlink this?'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            vm.$store.dispatch('loading')
            api.deleteLineNotify({ pageid: person.pageid, adminid: person.adminid }, function(
              error,
              response
            ) {
              if (error) {
                // reject(error)
              }
              var deleteIndex = vm.linenotifylist.findIndex(function(el) {
                return el.pageid == person.pageid && el.adminid == person.adminid
              })
              if (deleteIndex > -1) {
                vm.linenotifylist.splice(deleteIndex, 1)
              }
              vm.$store.dispatch('loading')
              // resolve()
            })
          }
        })
    },
    getDelayMessage: function() {
      var vm = this
      return new Promise((resolve, reject) => {
        api.getReplyDelay({ pageid: vm.selectedBot.pageid }, function(error, response) {
          if (error) {
            reject(error)
          }
          vm.delayMessageTime = response.data.replydelay / 1000
          resolve()
        })
      })
    },
    onCancelEditDelayMessage: function() {
      var vm = this
      vm.delayMessageTime = vm.cached_delay_message_time
      vm.isEditDelay = false
    },
    onSaveEditDelayMessage: function() {
      var vm = this
      vm.$store.dispatch('loading')
      return new Promise((resolve, reject) => {
        api.editReplyDelay(
          { pageid: vm.selectedBot.pageid, replydelay: vm.delayMessageTime * 1000 },
          function(error, response) {
            if (error) {
              reject(error)
              vm.$store.dispatch('loading')
            }
            vm.cached_delay_message_time = vm.delayMessageTime
            vm.isEditDelay = false
            vm.$store.dispatch('loading')
            resolve()
          }
        )
      })
    },
    decrementDelayMessage() {
      this.delayMessageTime -= 0.5
    },
    incrementDelayMessage() {
      this.delayMessageTime += 0.5
    },
    onChangeDelayMessage: function() {},
    getPauseStatus: function() {
      var vm = this
      return new Promise((resolve, reject) => {
        api.getPauseStatus({ pageid: vm.selectedBot.pageid }, function(error, response) {
          if (error) {
            reject(error)
          }
          try {
            vm.cachedNotReply = JSON.stringify(response.data)
          } catch (error) {}
          vm.notReplyWithinSecond = response.data.not_reply_within_seconds / 60
          vm.pauseStatus = response.data.notreplyduplicateintent === true
          resolve()
        })
      })
    },
    cancelEditLine: function() {
      var vm = this
      vm.line = JSON.parse(vm.cached_line)
      vm.isEditLine = false
    },
    saveEditLine: function() {
      var vm = this
      if (vm.$store.getters.getPackage !== 'premium') {
        vm.line = JSON.parse(vm.cached_line)
        vm.isEditLine = false
        return
      }
      vm.$store.dispatch('loading')
      api.saveLineToken(
        {
          pageid: vm.selectedBot.pageid,
          line_access_token: vm.line.line_access_token ? vm.line.line_access_token.trim() : '',
          line_channel_secret: vm.line.line_channel_secret ? vm.line.line_channel_secret.trim() : ''
        },
        function(error, response) {
          if (error) {
            vm.$store.dispatch('loading')
          }
          vm.cached_line = JSON.stringify(vm.line)
          vm.isEditLine = false
          vm.$store.dispatch('loading')
          location.reload()
        }
      )
    },
    getLineToken: function() {
      var vm = this
      return new Promise((resolve, reject) => {
        api.getLineToken({ pageid: vm.selectedBot.pageid }, function(error, response) {
          if (error) {
            reject(error)
            vm.$store.dispatch('loading')
          }
          vm.line = {
            line_access_token: response.data.line_access_token,
            line_channel_secret: response.data.line_channel_secret
          }
          resolve()
        })
      })
    },
    getLineNotify: function() {
      var vm = this
      return new Promise((resolve, reject) => {
        api.getLineNotify({ pageid: vm.selectedBot.pageid }, function(error, response) {
          if (error) {
            reject(error)
          }
          if (response.linenotifylist) {
            response.linenotifylist.map(async item => {
              if (item.adminid.charAt(0) === 'U') {
                var data = {
                  pageId: vm.selectedBot.pageid,
                  adminId: item.adminid
                }
                var response = await api.getAdminInfo(data)
                if (response.success && response.result) {
                  item.name = response.result.line_display_name
                  item.line_picture_url = response.result.line_picture_url
                }
              } else if (!item.name) {
                item.name = item.adminid
              }
              vm.linenotifylist.push(item)
            })

            vm.$store.commit('SET_LINENOTIFY_LIST', vm.linenotifylist)
          }
          resolve()
        })
      })
    },
    onUnsubscribeBot: function() {
      let vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to Unsubscribe this?'),
          text: vm.$t('Warning!! If you unsubscribe this, Bot data will be lost'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true,
          footer: vm.$t('if_you_want_any_help_text')
        })
        .then(result => {
          if (result.value) {
            vm.$store.dispatch('loading')
            let bot = vm.selectedBot
            api.unSubscribe(bot, function(error, response) {
              if (error) {
                console.error(error)
                vm.$store.dispatch('loading')
                return
              }

              let newbotlist = vm.botlist
              $.each(newbotlist, function(index, oldbot) {
                if (bot.pageid == oldbot.pageid) {
                  newbotlist.splice(index, 1)
                  return false
                }
              })

              vm.$store.dispatch('unselectBot')
              vm.$store.dispatch('updateBotlist', newbotlist)
              vm.$store.dispatch('updatePagelist')
              vm.$store.dispatch('loading')
              vm.$router.push('/' + vm.currentLang + '/allbots').catch(() => {})
            })
          }
        })
    },
    toggleBotStatus: function() {
      let vm = this
      let bot = Object.assign({}, vm.selectedBot)
      bot.status = !bot.status
      let data = {
        theme: bot.theme,
        page_access_token: bot.page_access_token,
        pageid: bot.pageid,
        status: bot.status
      }
      vm.$store.dispatch('loading')
      api.toggleBotStatus(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
          return
        }

        let newbotlist = vm.botlist
        $.each(newbotlist, function(index, oldbot) {
          if (bot.pageid === oldbot.pageid) {
            newbotlist[index].status = bot.status
            return false
          }
        })
        // console.log(bot)
        vm.botStatus = bot.status
        vm.$store.dispatch('selectBot', bot)
        vm.$store.dispatch('updateBotlist', newbotlist)
        vm.$store.dispatch('loading')
      })
    },
    togglePauseStatus: function() {
      let vm = this
      vm.pauseStatus = !vm.pauseStatus
    },

    cancelIsEditnotReplyWithinSecond() {
      var cached = JSON.parse(this.cachedNotReply)
      this.notReplyWithinSecond = cached.not_reply_within_seconds / 60
      this.pauseStatus = cached.notreplyduplicateintent === true
      this.isEditnotReplyWithinSecond = false
    },
    savePauseStatus() {
      let vm = this
      var data = {
        pageid: vm.selectedBot.pageid,
        notreplyduplicateintent: (vm.pauseStatus = vm.notReplyWithinSecond != 0 ? true : false),
        not_reply_within_seconds: vm.notReplyWithinSecond === '' ? 0 : vm.notReplyWithinSecond * 60
      }
      if (vm.notReplyWithinSecond === '') {
        vm.notReplyWithinSecond = 0
      }
      vm.$store.dispatch('loading')
      api.togglePauseStatus(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
          return
        }
        vm.cachedNotReply = JSON.stringify({
          notreplyduplicateintent: vm.pauseStatus,
          not_reply_within_seconds: vm.notReplyWithinSecond * 60
        })
        vm.isEditnotReplyWithinSecond = false
        vm.selectedBot.notreplyduplicateintent = vm.pauseStatus
        vm.$store.dispatch('loading')
      })
    },
    onCopyLink: function() {
      // let vm = this
      this.showCopyLink = true
      // setTimeout(() => {
      //   vm.showCopy = false
      // }, 1000)
    },
    onError: function() {}
  },
  watch: {
    tab: function() {
      this.updateRoute()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/billing/Billing.vue